import { Route, Routes } from 'react-router-dom';

import DieuChinhHoaDon from './dieu-chinh-hoa-don';
import DieuChinhHoaDonTrenHeThongKhac from './dieu-chinh-hoa-don-tren-he-thong-khac';
import HuyHoaDon from './huy-hoa-don';
import ThayTheHoaDon from './thay-the-hoa-don';
import ThayTheHoaDonTrenHeThongKhac from './thay-the-hoa-don-tren-he-thong-khac';
import WrongInvoice from './thong-bao-04-ss-hddt';
import { ROLE } from '../../Constant';
import { PrivateRoute } from '../components/PrivateRoute';
import BangKeHoaDonChietKhau from './bang-ke-hoa-don-chiet-khau';

export default function XuLySaiSot() {

  return (
    <Routes>
      <Route path="dieu-chinh-hoa-don/*" element={<PrivateRoute role={ROLE.ERROR_MANAGEMENT_INVOICE_ADJUSTMENT}> <DieuChinhHoaDon /></PrivateRoute>} />
      <Route path="dieu-chinh-hoa-don-tren-he-thong-khac/*" element={<PrivateRoute role={ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_ADJUSTMENT}> <DieuChinhHoaDonTrenHeThongKhac /></PrivateRoute>} />
      <Route path="huy-hoa-don/*" element={<PrivateRoute role={ROLE.ERROR_MANAGEMENT_INVOICECANCEL}> <HuyHoaDon /></PrivateRoute>} />
      <Route path="thay-the-hoa-don/*" element={<PrivateRoute role={ROLE.ERROR_MANAGEMENT_INVOICE_SUBSTITUDE}> <ThayTheHoaDon /></PrivateRoute>} />
      <Route path="thay-the-hoa-don-tren-he-thong-khac/*" element={<PrivateRoute role={ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_SUBSTITUDE}> <ThayTheHoaDonTrenHeThongKhac /></PrivateRoute>} />
      <Route path="thong-bao-04-ss-hddt/*" element={<PrivateRoute role={ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_WRONG_INVOICE}> <WrongInvoice /></PrivateRoute>} />
      <Route path="bang-ke-hoa-don-chiet-khau/*" element={<BangKeHoaDonChietKhau />} />

    </Routes>
  );
}
